// extracted by mini-css-extract-plugin
export default {"document":"tNyPLhlHkaoikwpdGz1S","table":"pqcTEcRJvo8r1YNcpDck"};